/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description environment utils
 */

class Environment {
	static readonly INTEGRATION = 'integration';
	static readonly PRODUCTION = 'production';
	static readonly LOCALHOST = 'localhost';

	isLocalhost = () => {
		const hostname = window.location.hostname;
		return hostname === Environment.LOCALHOST;
	};

	isIntegration = () => {
		const hostname = window.location.hostname;
		return hostname === Environment.LOCALHOST || hostname.split('.').pop() === 'tech';
	};

	getEnvironment = () => {
		return this.isIntegration() ? Environment.INTEGRATION : Environment.PRODUCTION;
	};
}

const env = new Environment();
export default env;
